import React from "react";
import BagcilarSidebar from "../Sidebar/BagcilarSidebar";
import BagcilarOtherServices from "../ServiceAreas/BagcilarServiceArea";
// import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const BagcilarIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
        BAĞCILAR HALI-KOLTUK YIKAMA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* İçerik */}
        <div className="order-1 md:order-2 md:col-span-2 space-y-6">
          <p>
            Bağcılar'da halı ve koltuk yıkama ihtiyaçlarınıza en hijyenik ve güvenilir
            çözümleri sunuyoruz. Modern teknolojilerle donatılmış tesislerimizde,
            ev tekstil ürünleriniz titizlikle temizlenir, sağlıklı bir yaşam alanı
            oluşturulmasına katkı sağlanır.
          </p>

          <p>
            Koltuklarınız kumaşına özel solüsyonlarla silinir, buharlı sistemle
            bakteri ve mikroplardan arındırılır. Halılarınız ise tam otomatik
            makinelerde yıkanıp, kurutma odalarında nemsiz şekilde kurutulur.
          </p>

          <p>
            <strong>Bağcılar Halı Yıkama hizmetinin sunduğu avantajlar:</strong>
          </p>

          <ul className="list-disc list-inside">
            <li>Bağcılar’ın tüm mahallelerinden ücretsiz servis</li>
            <li>Alerjen giderici ve antibakteriyel uygulamalar</li>
            <li>Derinlemesine koltuk ve halı yıkama hizmeti</li>
            <li>Yerinde koltuk yıkama imkânı</li>
            <li>Leke çıkarma garantisi</li>
            <li>2 gün içerisinde zamanında teslimat</li>
          </ul>

          <p>
            Bağcılar genelinde; Göztepe, 100. Yıl, Kirazlı, Yavuz Selim, Mahmutbey
            gibi mahallelerde mobil servis ağımızla hızlı ve güvenli hizmet sunmaktayız.
          </p>

          <p>
            Siparişleriniz online olarak ya da telefon yoluyla kolayca alınır,
            ürünleriniz adresinizden alınır ve paketli şekilde hijyenik olarak
            size teslim edilir.
          </p>

          <BagcilarSidebar />
          <BagcilarOtherServices />
        </div>

        {/* Sol Sidebar */}
        <div className="order-2 md:order-1 space-y-6">
          <LeftSidebar />
        </div>

        {/* Sağ Sidebar */}
        <div className="order-3 md:order-3 space-y-6">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default BagcilarIntro;
